import { React, useEffect, useState } from "react";
import ico_handy_orange from "../../../assets/icons/ico_handy_orange.svg";
import ico_huellas_green from "../../../assets/icons/ico_huellas_green.svg";
import ToolsInfoSection from "../../../components/toolsInfoSection";
import ToolsTab from "../../../components/toolsTab";
import VideoBanner from "../../../components/videoBanner";
import ico_escarabajo from "../../../assets/icons/ico_escarabajo.svg";
import img_abeja from "../../../assets/images/img_abeja.png";
import GoToPage from "../../../components/goToPage";
import ToolsActivityButton from "../../../components/toolsActivityButton";
const InsectCollectionMethodsScreen = ({ handle }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const cielo = "5Ke8oY85S8M";

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    handle(false);
    return () => handle(true);
  }, [handle]);

  return (
    <div className="w-full bg-[#002E0F] h-full overflow-hidden">
      {width > 1279 ? (
        <div>
          <div className="w-full lg:h-[1080px]  absolute">
            <VideoBanner idVideo={cielo}></VideoBanner>
          </div>
          <div className="w-full mx-auto text-white relative h-fit  overflow-hidden ">
            <div className="absolute -right-32 mt-[32rem]">
              <img
              
                src={img_abeja}
                className="lg:w-[50rem] md:w-[20rem] sm:w-[20rem] w-[20rem] 2xl:visible xl:invisible lg:invisible md:invisible sm:visible visible"
              ></img>
            </div>
            <div className="justify-center text-black h-fit text-left pt-[14rem] relative lg:pl-[8rem] md:pl-[3rem] sm:pl-[3rem] pl-[3rem]">
             <GoToPage
                page="/herramientas"
                side="left"
                name="Atrás"
                fontSizeXL="xl:text-xl"
                fontSizeL="lg:text-lg"
                fontSizeM="md:text-lg"
                fontSizeS="sm:text-base"
                fontSize="text-base"
                textType="font-bold"
                textColor="text-black"
                borderType="border-b-2"
                borderColor="border-black"
                iconSize="h-5"
                iconColor=""
                iconMargin="mr-5"
              ></GoToPage>
            </div>
            <div className="grid mb-52 relative lg:pl-32 md:pl-20 sm:pl-10 pl-10 2xl:pr-0 xl:pr-[15rem] lg:pr-[20rem] md:pr-[5rem] sm:pr-[5rem] pr-[5rem] mr-80 2xl:grid-cols-5 xl:grid-cols-1 lg:grid:cols-1 md:grid-cols-1 sm:grid-cols-1 grid-cols-1 2xl:pb-[10rem] xl:pb-[70rem] lg:pb-[70rem] md:pb-[90rem] sm:pb-[90rem] pb-[90rem] min-w-[10rem] pt-10 w-full  ">
              <div className="xl:h-[70rem] col-span-2 lg:h-[75rem] md:h-[75rem] sm:h-full h-full text-black lg:mr-10 bg-white w-full z-10 relative   ">
                <ToolsInfoSection
                  firstIcon={ico_handy_orange}
                  secondIcon={ico_huellas_green}
                  tag="Insectos"
                  title={
                    <h1 className="lg:text-5xl md:text-2xl sm:text-2xl text-2xl lg:px-10 md:px-0 sm:px-0 px-0 lg:text-left md:text-center sm:text-center text-center font-bold  my-10 ">
                      Métodos directos e <br /> indirectos de colecta <br />{" "}
                      para insectos
                    </h1>
                  }
                  text={
                    <div>
                      <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                        El uso de métodos directos o indirectos <b>dependerá del objetivo del muestreo</b>, es decir, de si solamente se desea conocer información sobre qué especies están presentes, o si, más bien, se pretende hacer comparaciones entre tipos de vegetación, temperatura, técnica de muestreo, época del año, entre otros factores.
                      </p>
                      <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                      Los <b>métodos directos</b> de colecta se refiere al uso de redes entomológicas con las que se persigue activamente el insecto para atraparlo en la red.

                      </p>
                      <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                        Los <b>métodos indirectos</b> pueden tener atrayentes
                        aromáticos, alimentos o ser de colores que atraen la
                        atención de los insectos; por ejemplo, recipientes
                        amarillos o rojos.
                      </p>
                    </div>
                  }
                ></ToolsInfoSection>
              </div>

              <div className="relative col-span-3 2xl:mt-[13rem] xl:mt-[0rem] lg:mt-[0rem] md:mt-[0rem] sm:mt-[0rem] mt-[0rem]  items-center">
                <div className=" grid relative gap-0">
                  <div className="h-full relative">
                    <img
                    
                      src=""
                      className="w-[50rem] mt-[3.5rem] right-0 absolute z-0 top-0"
                    ></img>
                    <div className="h-44 w-full bg-[#F77E0B] relative 2xl:mt-[25.6rem] xl:mt-0 md:mt-0 sm:mt-0 mt-0 pl-20">
                      <div className="grid grid-cols-2 grid-rows-1 relative text-white">
                        <div className="inline-flex items-center py-5 ml-10">
                          <img loading="lazy" src={ico_escarabajo}></img>
                          <label className="ml-5 text-2xl font-bold">
                            Caso <br /> de éxito
                          </label>
                        </div>
                        <p className="py-16 text-lg">
                          Atrae insectos como polillas nocturnas, <br />{" "}
                          escarabajos y otros insectos voladores.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="relative w-full h-full items-center  text-white bg-[#002E0F] pr-10 pt-5">
                    <ToolsTab
                    firstTitle="Bosques, fragmentos de bosques, plantaciones"
                    secondTitle="Resultados y beneficios"
                      firstTab={
                        <div>
                          <p className="text-xl mb-5">
                          Las trampas se colocan según el grupo que desee recolectar. Por ejemplo, para algunas especies de mariposas, las trampas pueden instalarse en los estratos medios y altos del bosque.
                          </p>
                          <p className="text-xl mb-5">
                            Otros métodos de captura se colocan a nivel del
                            suelo. Por ejemplo, en la vegetación baja de los
                            claros del bosque, donde los insectos suelen estar
                            más activos.
                          </p>
                        </div>
                      }
                      secondTab={
                        <div>
                          <p className="text-xl mb-5">
                            La diversidad de insectos en un sitio puede brindar
                            información muy valiosa sobre la calidad del
                            hábitat, independientemente de si dichos hábitats
                            están sanos o alterados.
                          </p>
                          <p className="text-xl mb-5">
                            Contar con una línea base de los insectos en un
                            sitio puede ser una ventaja durante un recorrido
                            turístico, sobre todo para empresas turísticas ante
                            la dificultad de ver animales más grandes en los
                            bosques, ya sea por la hora o por el tiempo del
                            recorrido.
                          </p>
                          <p className="text-xl mb-5">
                            Un inventario de insectos puede dar indicios de la
                            presencia de plagas en los cultivos.
                          </p>
                        </div>
                      }
                    ></ToolsTab>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="w-full absolute ">
            <VideoBanner idVideo={cielo}></VideoBanner>
            <div className=" absolute right-0 bottom-0 ">
              <img
              
                src={img_abeja}
                className="lg:w-[35rem] md:w-[25rem] sm:w-[15rem] w-[15rem]"
              ></img>
            </div>
          </div>

          <div className="grid grid-cols-1   2xl:px-52  lg:px-30 md:px-10 sm:px-14 px-10 pb-[40rem]">
            <div className="justify-center text-black h-fit text-left lg:mt-[25rem] md:mt-[15rem] sm:mt-[7rem] mt-[7rem] relative ">
            <GoToPage
                page="/herramientas"
                side="left"
                name="Atrás"
                fontSizeXL="xl:text-xl"
                fontSizeL="lg:text-lg"
                fontSizeM="md:text-lg"
                fontSizeS="sm:text-base"
                fontSize="text-base"
                textType="font-bold"
                textColor="text-black"
                borderType="border-b-2"
                borderColor="border-black"
                iconSize="h-5"
                iconColor=""
                iconMargin="mr-5"
              ></GoToPage>
            </div>

            <div className=" h-fit text-black  bg-white w-full z-10 relative bottom-0  mt-[4rem]  ">
             
              <ToolsInfoSection
                  firstIcon={ico_handy_orange}
                  secondIcon={ico_huellas_green}
                  tag="Insectos"
                  title={
                    <h1 className="lg:text-5xl md:text-2xl sm:text-2xl text-2xl lg:px-10 md:px-0 sm:px-0 px-0 lg:text-left md:text-center sm:text-center text-center font-bold  my-10 ">
                      Métodos directos e <br /> indirectos de colecta <br />{" "}
                      para insectos
                    </h1>
                  }
                  text={
                    <div>
                      <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                      El uso de métodos directos o indirectos <b>dependerá del objetivo del muestreo</b>, es decir, de si solamente se desea conocer información sobre qué especies están presentes, o si, más bien, se pretende hacer comparaciones entre tipos de vegetación, temperatura, técnica de muestreo, época del año, entre otros factores.
                      </p>
                      <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                        Los <b>métodos directos</b> de colecta se refiere al uso de redes entomológicas con las que se persigue activamente el insecto para atraparlo en la red.
                      </p>
                      <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base lg:pb-40 md:pb-40 sm:pb-32 pb-32">
                        Los <b>métodos indirectos</b> pueden tener atrayentes
                        aromáticos, alimentos o ser de colores que atraen la
                        atención de los insectos; por ejemplo, recipientes
                        amarillos o rojos.
                      </p>
                    </div>
                  }
                ></ToolsInfoSection>
            </div>
            <div className="relative w-full h-full items-center lg:mt-32 md:mt-10 sm:mt-5 mt-5  text-white bg-[#002E0F]">
            <ToolsTab
            firstTitle="Bosques, fragmentos de bosques, plantaciones"
            secondTitle="Resultados y beneficios"
                      firstTab={
                        <div>
                          <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                          Las trampas se colocan según el grupo que desee recolectar. Por ejemplo, para algunas especies de mariposas, las trampas pueden instalarse en los estratos medios y altos del bosque.
                          </p>
                          <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                            Otros métodos de captura se colocan a nivel del
                            suelo. Por ejemplo, en la vegetación baja de los
                            claros del bosque, donde los insectos suelen estar
                            más activos.
                          </p>
                        </div>
                      }
                      secondTab={
                        <div>
                          <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                            La diversidad de insectos en un sitio puede brindar
                            información muy valiosa sobre la calidad del
                            hábitat, independientemente de si dichos hábitats
                            están sanos o alterados.
                          </p>
                          <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                            Contar con una línea base de los insectos en un
                            sitio puede ser una ventaja durante un recorrido
                            turístico, sobre todo para empresas turísticas ante
                            la dificultad de ver animales más grandes en los
                            bosques, ya sea por la hora o por el tiempo del
                            recorrido.
                          </p>
                          <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                            Un inventario de insectos puede dar indicios de la
                            presencia de plagas en los cultivos.
                          </p>
                        </div>
                      }
                    ></ToolsTab>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InsectCollectionMethodsScreen;
